module.exports = __webpack_public_path__ + "media/insights/books_icon-43d1d7ff.png";